import {getSkus} from "../../utils/orderUtils";

export const createOrder = async ({paymentMode, designId, data}) => {
    let url = global.config.server_path+'order/add/';
    let payload = {};
    payload['skus'] = getSkus({designId, data});
    payload['payment_mode'] = paymentMode;
    payload['designId'] = designId;
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify(payload)})
        .then(resp => resp.json())
        .then(resp => {
            if (resp.response_code === 1) return Promise.resolve(resp.data);
            else return Promise.reject(resp);
        })
        .catch(e => {
            console.error("Error while creating order: ", e);
            return Promise.reject(e);
        })
};

export const fetchCredits = async () => {
    let url = global.config.server_path+'user/credits/';
    return fetch(url ,{method: 'GET', 'credentials' : 'include'})
        .then(resp => resp.json())
};

export const confirmOrder = async ({id, paymentDetails}) => {
    let url = global.config.server_path+'order/confirm/';
    let payload = {
        id,
        paymentDetails
    };
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify(payload)})
        .then(resp => resp.json())
        .then(resp => {
            if (resp.response_code === 1) return Promise.resolve(resp.data);
            else return Promise.reject(resp);
        })
};